import { useState } from "react";

import { useCanAddTeamMembersToJob } from "@js/apps/jobs/hooks/use-can-add-team-members-to-job";

export const useAddTeamMemberDrawer = (jobOwnerId: number) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleOpen = () => {};
  const openDrawer = () => setIsOpen(true);
  const handleClose = () => setIsOpen(false);

  const { canAddTeamMembersToJob } = useCanAddTeamMembersToJob(jobOwnerId);

  return {
    isAddingTeamMembersEnabled: canAddTeamMembersToJob,
    isOpen,
    handleOpen,
    handleClose,
    openDrawer,
  };
};
